import Countdown from "react-countdown";
import { useNavigate } from "react-router-dom";
import { rendererCountDown } from "../utilsIDO";
import { formatNumber } from "../../../components/utils/FormatNumber";
import moment from "moment";
import { CampaignType } from "../../../type";

const ProjectCard = ({ cardData }: { cardData: CampaignType }) => {
  const convertToTimestamp = (isoString: any) =>
    isoString ? new Date(isoString).getTime() : null;

  const timeStart: any = convertToTimestamp(cardData?.start_time);
  const timeEnd: any = convertToTimestamp(cardData?.end_time);
  const currentTime: any = new Date().getTime();
  const navigate = useNavigate();
  function goToDetail(id: any): void {
    navigate(`/launchpads/${id}`);
  }
  return (
    <div className="colum">
      <div className="guide-open" onClick={() => goToDetail(cardData?.slug)}>
        <div className="line-open">
          <img src="./images/line-open.png" alt="" />
        </div>
        <div className="box-img">
          <img src={cardData?.background} alt="" />
          <div className="text-ido">{cardData?.campaign_type}</div>
        </div>
        <div className="avatar-open">
          <div className="avt-img">
            <img src={cardData?.avatar} alt="" />
          </div>
        </div>
        <div className="start-time">
          {currentTime < timeStart || !timeStart ? "Starts In" : "Ends In"}:{" "}
          <span>
            {timeStart ? (
              <Countdown
                renderer={rendererCountDown}
                date={currentTime < timeStart ? timeStart : timeEnd}
              />
            ) : (
              "TBA"
            )}
          </span>
        </div>
        <div className="info-open-box">
          <div className="title">{cardData?.title}</div>
          <div className="item">
            <div className="txt-l">Join Network</div>
            <div className="txt-r">
              <img src={cardData?.currency?.chain?.logo} alt="" />
              {cardData?.currency?.chain?.name}
            </div>
          </div>
          <div className="item">
            <div className="txt-l">Token Network</div>
            <div className="txt-r">
              <img src={cardData?.token?.chain?.logo} alt="" />
              {cardData?.token?.chain?.name}
            </div>
          </div>
          <div className="item">
            <div className="txt-l">Symbol</div>
            <div className="txt-r">{cardData?.token?.symbol}</div>
          </div>
          <div className="item">
            <div className="txt-l">Price</div>
            <div className="txt-r">
              {formatNumber(cardData?.price, 8)} {cardData?.currency?.symbol}
            </div>
          </div>
          <div className="item">
            <div className="txt-l">Total Raise </div>
            <div className="txt-r">
              {formatNumber(cardData?.total_raise, 8)}{" "}
              {cardData?.currency?.symbol}
            </div>
          </div>
          <div className="item">
            <div className="txt-l">IDO Date</div>
            <div className="txt-r">
              {moment(cardData?.start_time).format("MMMM Do YYYY")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
